export function convertLocationFromGemmiciAutocompleteItem(data) {
  let placeType = data.properties.placeType;
  let bbox = [];
  switch (placeType) {
    case "administrative":
      bbox = data.properties.administrative.bbox;
      break;
    case "region":
      bbox = data.properties.region.bbox;
      break;
    case "departement":
      bbox = data.properties.departement.bbox;
      break;
    default:
      bbox = data.properties.city.bbox;
      break;
  }
  if (placeType === "departement" || placeType === "administrative") {
    placeType = "region";
  }
  return {
    shortName: data.properties.shortName,
    longName: data.properties.longName,
    placeType,
    coordinates: data.geometry.coordinates,
    bbox,
    id: data.id
  };
}
